import {AbstractControl, ValidatorFn, Validators} from '@angular/forms';
import {ControlBuilder} from '../../dynamic-field/control-builder.type';
import {buildAsyncValidators, buildDefaultValidators} from '../../dynamic-field/default-control-builder';
import {NumberFieldConfig} from './number-field.config';
import {NumberTypeEnum} from "./number-type.enum";

export const numberFieldControlBuilder: ControlBuilder = (fieldConfig: NumberFieldConfig, formBuilder) => {

    const {disabled, value} = fieldConfig;

    const validators = buildDefaultValidators(fieldConfig);

    if (fieldConfig.maxValue) {
        validators.push(Validators.max(fieldConfig.maxValue));
    }

    if (fieldConfig.minValue) {
        validators.push(Validators.min(fieldConfig.minValue));
    }
    if (fieldConfig.numberType === NumberTypeEnum.integer) {
        validators.push(isNumberIntegerValidator.bind(this, fieldConfig))
    }

    const asyncValidators = buildAsyncValidators(fieldConfig);

    return formBuilder.control(
        {
            disabled,
            value: (!isNaN(value as number)) ? value : null
        },
        validators,
        asyncValidators
    );
};
export const buildNumberFieldValidators: (fieldConfig: NumberFieldConfig) => ValidatorFn[] =
    (config): ValidatorFn[] => {
        const validators = buildDefaultValidators(config);
        if (config.maxValue) {
            validators.push(Validators.max(config.maxValue));
        }
        if (config.numberType === NumberTypeEnum.integer) {
            validators.push(isNumberIntegerValidator.bind(this, config))
        }

        if (config.minValue) {
            validators.push(Validators.min(config.minValue));
        }

        return validators;
    };

export function isNumberIntegerValidator(field: NumberFieldConfig, control: AbstractControl): { isInteger: string } {
    // const exp = RegExp('^-?[1-9]+([0-9]+)*$').test(control.value);
    const exp = Number.isInteger(parseFloat(control.value));

    if (field.numberType === NumberTypeEnum.integer && control.value !== null && !exp) {
        return {
            isInteger: 'isInteger'
        };
    }
}
